(function(window, quizService) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.progressTracker = (function() {
      var _didAttachToEndedEvent = false;
      var _didAttachToPlayEvent = false;
      var _sampleRateInMilliseconds = 15000;
      var _intervalId;
      var _playCallbackFunction;
      var _mergeToleranceInMilliseconds = 500;
      var _videoEndToleranceInMilliseconds = 1000;

      var processPlayedSegments = function(played) {
         var numberPlayedSegments = played.length;
         if (numberPlayedSegments < 1) {
            return [];
         }
         var mergedPlayedInMilliseconds = [{start: played.start(0) * 1000, end: played.end(0) * 1000}];
         var mergedPlayedIndex = 0;
         var i;

         for (i = 1; i < numberPlayedSegments; i++) {
            if (mergedPlayedInMilliseconds[mergedPlayedIndex].end >= played.start(i) * 1000 - _mergeToleranceInMilliseconds) {
               mergedPlayedInMilliseconds[mergedPlayedIndex].end = played.end(i) * 1000;
            } else {
               mergedPlayedInMilliseconds.push({start: played.start(i) * 1000, end: played.end(i) * 1000});
               mergedPlayedIndex++;
            }
         }

         return mergedPlayedInMilliseconds;
      };

      var computePercentageViewed = function(video) {
         var completedSamples = [];
         var i;
         var j;
         var videoStartMilliseconds;
         var videoEndMilliseconds;
         var isEndOfVideo;
         var firstSample;
         var lastSample;
         var entireVideoWasWatched;
         var mergedPlayedInMilliseconds;
         var videoDurationInMilliseconds = video.duration * 1000;

         mergedPlayedInMilliseconds = processPlayedSegments(video.played);

         for (i = 0; i < mergedPlayedInMilliseconds.length; i++) {
            videoStartMilliseconds = mergedPlayedInMilliseconds[i].start;
            videoEndMilliseconds = mergedPlayedInMilliseconds[i].end;

            isEndOfVideo = videoDurationInMilliseconds - video.currentTime * 1000 < _videoEndToleranceInMilliseconds;

            if (!isEndOfVideo && videoEndMilliseconds - videoStartMilliseconds < _sampleRateInMilliseconds) {
               continue;
            }
            firstSample = Math.floor(videoStartMilliseconds / _sampleRateInMilliseconds);
            if (videoStartMilliseconds % _sampleRateInMilliseconds !== 0) {
               firstSample += 1;
            }

            lastSample = Math.floor(videoEndMilliseconds / _sampleRateInMilliseconds);
            if (!isEndOfVideo) {
               lastSample -= 1;
            }

            if (lastSample < firstSample) {
               continue;
            }

            for (j = firstSample; j <= lastSample; j++) {
               completedSamples.push(j);
            }
         }

         quizService.sendProgress(_sampleRateInMilliseconds, completedSamples);

         entireVideoWasWatched = completedSamples.length === Math.ceil(videoDurationInMilliseconds / _sampleRateInMilliseconds);
         if (entireVideoWasWatched) {
            stopInterval();
            video.removeEventListener('play', _playCallbackFunction, false);
         }
      };

      var attachToEndedEvent = function(video) {
         var endedCallbackFunction = function() {
            sendProgress(video);
            stopInterval();
         };
         video.addEventListener('ended', endedCallbackFunction, false);
         _didAttachToEndedEvent = true;
      };

      var attachToPlayEvent = function(video) {
         _playCallbackFunction = function() {
            if (_intervalId !== -1) {
               return;
            }

            setupProgressInterval(video);
         };
         video.addEventListener('play', _playCallbackFunction, false);
         _didAttachToPlayEvent = true;
      };

      var sendProgress = function(video) {
         if (!video) {
            return;
         }

         if (!_didAttachToEndedEvent) {
            attachToEndedEvent(video);
         }

         if (!_didAttachToPlayEvent) {
            attachToPlayEvent(video);
         }

         computePercentageViewed(video);
      };

      var stopInterval = function() {
         if (_intervalId !== -1) {
            window.clearInterval(_intervalId);
            _intervalId = -1;
         }
      };

      var setupProgressInterval = function(video) {
         var intervalFunction = function() {
            sendProgress(video);
            if (video.paused) {
               window.clearInterval(_intervalId);
               _intervalId = -1;
            }
         };
         _intervalId = window.setInterval(intervalFunction, _sampleRateInMilliseconds);
      };

      var start = function(video, sampleRateInMilliseconds) {
         _didAttachToEndedEvent = false;
         _didAttachToPlayEvent = false;
         _sampleRateInMilliseconds = sampleRateInMilliseconds;
         stopInterval();
         setupProgressInterval(video);
      };

      return {
         start: start
      };
   }());
}(window, window.TSC.quizService));
